import { ModelBase } from 'store/model-base';

export class NowEsimActivation extends ModelBase {
    public static storeName: string = 'nowEsimActivation';

    public orderKey: string;
}
